import api from '../../../api'
import { executeResponseError } from '../../../helpers'
import {setJsonAction, setUser} from '../user/actions'

export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN'
export const LOGIN_POPUP_SHOW = 'LOGIN_POPUP_SHOW'

export const signInAction = (data, alert) => {
	return async () => {
		try {
			const formData = new FormData()
			formData.set('username', data.username)
			formData.set('password', data.password)
			const res = await api.auth.signIn(formData)
			if (res?.data?.status && res?.data?.status === 'error') alert.error(res?.data?.data)
			if (res?.data) return res.data
		} catch (e) {
			const error = executeResponseError(e, 'User auth error')
			throw new Error(error || '')
		}
	}
}
export const setShowLoginPopup = (bool) => {
	return {
		payload: bool,
		type: LOGIN_POPUP_SHOW
	}
}
export const setToken = (str) => {
	return {
		payload: str,
		type: SET_ACCESS_TOKEN
	}
}
export const setLogOut = () => {
	return async dispatch => {
		dispatch(setToken(''))
		dispatch(setShowLoginPopup(true))
		dispatch(setUser(null))
		dispatch(setJsonAction(null))
	}


}



